$(function () {
    $(document).on('click', '.jsDoctorsListFavourite', function (event) {
        event.preventDefault();
        var serviceUrl = $(this).data('service');
        var heart = $(this).parent();
        var model = {
            workplaceId: $(this).data('workplace'),
            isFavourite: !(heart.hasClass('isPersonMarked'))
        };
        $.post(serviceUrl, model, function (data) {
            console.log(data);
            if (data == true) {
                heart.toggleClass('isPersonMarked');
            }
        });
    });
});